import type { AgentComponentType } from '@reach/shared-types/agent-components';
import { Button } from '../../../components/ui/button';
import { COMPONENT_TYPE_COPY, STATUS_COPY } from '../agents-copy';
import { StatusNote } from '../StatusNote';
import { useAgentComponentList } from '../useAgentComponents';
import { ComponentTable } from './ComponentTable';
import styles from './ComponentListContent.module.css';

interface ComponentListContentProps {
  type: AgentComponentType;
}

export const ComponentListContent = ({ type }: ComponentListContentProps) => {
  const {
    data: components,
    isLoading,
    hasNextPage,
    fetchNextPage,
    isFetchingNextPage,
  } = useAgentComponentList(type);
  const { emptyNote, loadErrorNote } = COMPONENT_TYPE_COPY[type];

  if (isLoading) {
    return <StatusNote>{STATUS_COPY.loading}</StatusNote>;
  }
  if (!components) {
    return <StatusNote tone="error">{loadErrorNote}</StatusNote>;
  }
  const partnerHasComponents = components.length > 0;
  if (!partnerHasComponents) {
    return <p className={styles.empty}>{emptyNote}</p>;
  }
  const loadMoreLabel = isFetchingNextPage ? STATUS_COPY.loading : STATUS_COPY.loadMore;
  return (
    <>
      <ComponentTable type={type} components={components} />
      {hasNextPage && (
        <Button
          type="button"
          variant="outline"
          className={styles.loadMore}
          disabled={isFetchingNextPage}
          onClick={() => fetchNextPage()}>
          {loadMoreLabel}
        </Button>
      )}
    </>
  );
};
